import { ClassifyPicker } from '@/components/classification/ClassifyPicker'
import type { Selection } from '@/domain/work-order.types'

export interface PromptClassificationFieldProps {
	value: Selection
	/** Pickable axes with their values, from the registry. */
	axes: Parameters<typeof ClassifyPicker>[0]['axes']
	onChange: (next: Selection) => void
}

/**
 * The classification tuple as a labelled form field.
 *
 * Wraps `ClassifyPicker` with the copy that explains what an EMPTY tuple means —
 * "applies everywhere", not "unset". That distinction is the one authors get wrong,
 * and resolution treats an absent axis as a wildcard, so the caption has to say it.
 *
 * Presentational + storied.
 */
export function PromptClassificationField({ value, axes, onChange }: PromptClassificationFieldProps) {
	return (
		<div>
			<span className="mb-1 block text-ds-2xs text-ds-text-subtle">
				Classification — which contexts this prompt applies to. Optional: an empty tuple applies everywhere.
			</span>
			<ClassifyPicker
				value={value}
				axes={axes}
				onChange={onChange}
				emptyLabel="Applies to all contexts — add an axis to narrow it."
			/>
		</div>
	)
}
